module.exports = __webpack_public_path__ + "img/userIcon.277ea93d.svg";